import { Heading } from "@digipost/dds-heading-react";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import BankId from "../infrastructure/assets/bankid.svg?react";
import Buypass from "../infrastructure/assets/buypass.svg?react";
import Translated from "../infrastructure/components/Translated";
import { get } from "../infrastructure/digipost-fetch";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { LoginCard } from "../virksomhet/LoginCard";
import { LoginMethod, LoginRole } from "../virksomhet/LoginMethod";
import styles from "./Admin.module.less";

const Admin: FC = () => {
  const navigate = useNavigate();
  const rootPath = useRootPath();

  const [hasAccess, setHasAccess] = useState<boolean>(false);

  useEffect(() => {
    get("/post/api/admin/access")
      .then(() => {
        setHasAccess(true);
      })
      .catch(() => {
        navigate(rootPath);
      });
  });

  if (hasAccess) {
    const returnUrl = "/admin/";
    return (
      <div className={styles.container}>
        <Heading level={1} size={"small"}>
          <Translated textKey="admin.header" />
        </Heading>
        <div className={styles.loginContent}>
          <LoginCard
            title={"virksomhet.bankid_title"}
            description={"virksomhet.bankid_desc"}
            icon={<BankId />}
            returnUrl={returnUrl}
            loginRole={LoginRole.ADMIN}
            loginMethod={LoginMethod.BANK_ID}
          />
          <LoginCard
            title={"virksomhet.buypass_title"}
            description={"virksomhet.buypass_desc"}
            icon={<Buypass />}
            returnUrl={returnUrl}
            loginRole={LoginRole.ADMIN}
            loginMethod={LoginMethod.BUYPASS}
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Admin;
